import { render, staticRenderFns } from "./MovementSensorView.vue?vue&type=template&id=80b60e30&"
import script from "./MovementSensorView.vue?vue&type=script&lang=js&"
export * from "./MovementSensorView.vue?vue&type=script&lang=js&"
import style0 from "./MovementSensorView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MovementSensorView.vue"
export default component.exports